import {Component, inject} from '@angular/core'
import {MatButton} from '@angular/material/button'
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle
} from '@angular/material/dialog'

@Component({
  selector: 'spb-error-dialog',
  imports: [
    MatDialogTitle,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    MatDialogContent
  ],
  templateUrl: './error-dialog.component.html'
})
export class ErrorDialogComponent {
  public readonly data = inject(MAT_DIALOG_DATA)
}
